export enum TabState {
  REGULAR = 'Regular',
  HOVER = 'Hover',
}

export enum ButtonStyleOptions {
  RECTANGLE_FILLED = 0,
  ROUND_RECTANGLE_FILLED = 1,
  PILL_FILLED = 2,
  RECTANGLE_OUTLINE = 3,
  ROUND_RECTANGLE_OUTLINE = 4,
  PILL_OUTLINE = 5,
}

export const COLORS = {
  WHITE: { value: 'rgb(255, 255, 255)', name: null, opacity: 1 },
  TRANSPARENT: { value: 'rgb(255, 255, 255)', name: null, opacity: 0 },
  BLACK_SHADOW: { value: 'rgb(0, 0, 0)', name: null, opacity: 0.15 },
} as const;

export const BUTTON_STYLE_CONFIG = {
  SLIDER_LIMITS: {
    BORDER_WIDTH: { min: 0, max: 5 },
    CORNER_RADIUS: { min: 0, max: 60 },
  },
  FONT_LIMITS: {
    MIN_SIZE: 12,
    MAX_SIZE: 20,
  },
  THUMBNAIL_SIZE: 51,
} as const;

export const DATA_HOOKS = {
  // Color and opacity pickers
  COLOR_OPACITY_PICKER: {
    FILL_PREVIEW: 'color-opacity-picker-fill-preview',
    SLIDER: 'color-opacity-picker-slider',
    NUMBER_INPUT: 'color-opacity-picker-number-input',
  },
  SIMPLE_COLOR_PICKER: {
    FILL_PREVIEW: 'simple-color-picker-fill-preview',
  },
} as const;

export const VISIBLE_LINK_PANEL_SECTIONS = {
  PageLink: true,
  ExternalLink: true,
  NoLink: true,
  AnchorLink: true,
  PhoneLink: false,
  EmailLink: false,
  DocumentLink: true,
  LoginToWixLink: false,
  EdgeAnchorLinks: false,
  PopupLink: true,
} as const;

export const REDIRECT_LINK_PANEL_SECTIONS = {
  NoLink: true,
  PageLink: true,
  AnchorLink: true,
  ExternalLink: false,
  EmailLink: false,
  PhoneLink: false,
  DocumentLink: false,
  PopupLink: false,
  LoginToWixLink: false,
  EdgeAnchorLinks: false,
} as const;
